import ToggleSwitch from './ToggleSwitch'
import { forwardRef } from 'react'
import { preventDefault } from '../../utils'
import type { ToggleSwitchProps } from './types'

const ClientToggleSwitch = forwardRef<HTMLInputElement, ToggleSwitchProps>(function ClientToggleSwitch(
  { onChange: onChange_, onClick: onClick_, ...props },
  ref
) {
  const { disabled } = props
  const onChange = disabled ? preventDefault : onChange_
  const onClick = disabled ? preventDefault : onClick_
  return <ToggleSwitch {...props} onChange={onChange} onClick={onClick} ref={ref} />
})

export default ClientToggleSwitch
